/**
 * WHICH LINES THE CONNECT COACH SAYS for a sign-in (D-92's light-only surfaces: the connect coach, part 1, 2026-10-26).
 *
 * Beside what every coach says (what Composio is, the four promises), a sign-in may need one of three lines. Today's
 * coach (./ComposioConnectCoach.tsx) and the new design's (src/design/pavilion/connectcoach/) both ask this, so the two
 * say the same lines for the same sign-in. Moved verbatim from today's coach's conditions;
 * tests/landing/connectCoach/connectCoachKeepsWhatItSays.test.tsx pins every case through the host.
 */
export interface ConnectCoachLines {
  /** Email journey (2026-08-20): the inbox the person said they are connecting, which the sign-in is pinned to. */
  intendedAddress?: string;
  /**
   * Google signs in with the account already open in this browser unless asked (2026-10-10, Miles's "it keeps defaulting
   * to Justin's Google account"): Gmail or any Google app, when no inbox was named.
   */
  googleChoose: boolean;
  /** An Outlook inbox may need its admin's approval, which the admin gives from their console, never by signing in. */
  adminWarning: boolean;
}

export function connectCoachLines(intendedAddress?: string, toolkitSlug?: string): ConnectCoachLines {
  return {
    ...(intendedAddress ? { intendedAddress } : {}),
    googleChoose: !intendedAddress && /^(gmail|google[a-z]*)$/.test(String(toolkitSlug || '')),
    adminWarning: !!intendedAddress && toolkitSlug === 'outlook',
  };
}
